import styled from "styled-components";
// import { InfoCard as MyInfoCard } from './InfoCard/index';

export const Content = styled.div`
  background: var(--background);
  width: 100%;
  min-height: 100vh;
  padding: 2rem;
  color: var(--color-text);
`;

// export const Content = styled.div`
//   background: var(--background);
//   margin-top: 64px;
//   width: 100%;
//   min-height: calc(100vh - 64px);
//   padding: 2rem;
//   color: var(--color-text);

//   @media(min-width:960px) {
//     margin-top: 0;
//     height: 100vh;
//     /* width: calc(100% - 214px); */
//     padding: 2.4rem;
//   }
// `;

export const Header = styled.header`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Title = styled.h2`
  font-weight: 600;
  color: var(--grayLv3);
  font-size: 2rem;
  /* margin-bottom: 16px; */
`;

export const Subtitle = styled.h2`
  display: inline-block;
  font-family: OpenSans-Bold;
  font-weight: normal;
  font-size: 1.4rem;

  @media (min-width: 960px) {
    font-size: 2.4rem;
  }
`;

export const H2 = styled.h2`
  color: var(--grayLv1);
  font-family: OpenSans-Bold;
  font-weight: normal;
  font-size: 1.4rem;
  display: inline-flex;

  @media (min-width: 1920px) {
    font-size: 1.6rem;
  }
`;

export const Section = styled.section`
  max-width: 100%;
  max-height: calc(100% - 96px);
  /* overflow: auto; */
  margin-top: 2rem;

  @media (min-width: 960px) {
    margin-top: 4rem;
  }
`;

export const Main = styled.main`
  max-width: 100%;
  max-height: calc(100% - 64px);
  margin-top: 2rem;
  padding: 24px;
  /* padding-right: 8px; */
  border-radius: 4px;
  background-color: var(--backgroundContent);
  overflow: hidden;
`;

// export const Main = styled.main`
//   max-width: 100%;
//   max-height: calc(100% - 64px);
//   margin-top: 2rem;
//   padding: 24px;
//   /* padding-right: 8px; */
//   border-radius: 4px;
//   background-color: var(--backgroundContent);

//   @media (min-width: 960px) {
//     overflow: auto;
//     /* padding-right: 16px; */
//     max-height: calc(100% - 88px);
//     margin-top: 3.8rem;
//   }
// `;

export const DashboardMain = styled.main`
  max-width: 100%;
  max-height: calc(100% - 64px);
  margin-top: 2rem;
  padding: 24px;
  /* padding-right: 8px; */
  border-radius: 4px;
  background-color: var(--backgroundGray);

  @media (min-width: 960px) {
    overflow: auto;
    padding-right: 16px;
    max-height: calc(100% - 88px);
    margin-top: 4rem;
  }
`;

export const SectionTitle = styled.h3`
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--grayLv4);
`;

// export const InfoCard = styled(MyInfoCard)``;
